import Helpers from "@/util/Helpers";

export default ({ instance, baseURL, headers}) => {
    const apiCalls = {
        reCaptchaSiteVerify (token) {
            return instance({
                method: 'post',
                baseURL,
                url: 'ReCaptcha/siteVerify',
                responseType: 'json',
                headers: headers,
                data: Helpers.aplicarValidacoes({ 'token': token })
            })
        },
    }
    return apiCalls;
}
